import * as React from 'react';
import { components } from 'react-select';
export const ValueContainer = (internalProps) => {
    const { children } = internalProps;
    const [selectedItems, valueContainerComponents] = children;
    return (React.createElement(components.ValueContainer, Object.assign({}, internalProps),
        selectedItems && selectedItems.length
            ? `${internalProps.selectProps.t(internalProps.selectProps.countTranslationKey, {
                count: selectedItems.length,
            })} `
            : selectedItems,
        valueContainerComponents));
};
//# sourceMappingURL=ValueContainer.js.map